import React from "react";
import { Link } from "react-router-dom";
import { CH9, END_FRAME } from "@/home/content";
import { CTALink, Eyebrow, GoldRule, Reveal } from "@/components/Editorial";

/* CH9 — deliberately smaller and quieter than the alcohol story */
export const Ch9Section = () => (
  <section data-testid="chapter-9" className="relative z-10 bg-[#111111] border-t border-white/5 px-6 sm:px-10 xl:px-16 py-20 sm:py-24">
    <Reveal className="max-w-xl">
      <Eyebrow dark>{CH9.eyebrow}</Eyebrow>
      <h2 className="hcc-serif text-2xl sm:text-3xl font-medium text-[#F7F1E7] mt-4">{CH9.headline}</h2>
      <p className="mt-4 text-sm font-light leading-relaxed text-[#F7F1E7]/60">{CH9.body}</p>
      <Link
        to={CH9.cta.to}
        data-testid={CH9.cta.testId}
        className="inline-block mt-6 text-[11px] uppercase tracking-[0.2em] text-[#C7A45D] border-b border-[#C7A45D]/50 pb-1 hover:border-[#C7A45D] transition-colors"
      >
        {CH9.cta.label}
      </Link>
    </Reveal>
  </section>
);

/* End frame — clean ivory corporate contact band */
export const EndFrameBand = () => (
  <section data-testid="end-frame" className="relative z-10 bg-[#F7F1E7] text-[#1c1713] px-6 sm:px-10 py-24 sm:py-32 text-center">
    <Reveal>
      <GoldRule className="mx-auto" />
      <h2 className="hcc-serif text-3xl sm:text-4xl lg:text-5xl font-medium mt-8 max-w-2xl mx-auto leading-tight">
        {END_FRAME.headline}
      </h2>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        {END_FRAME.ctas.map((c, i) => (
          <CTALink key={c.to} to={c.to} testId={c.testId} solid={i === 0}>
            {c.label}
          </CTALink>
        ))}
      </div>
    </Reveal>
  </section>
);
